<template>
    <div class="main_content">
        <router-link tag="div" to="/drive" class="btn btn-sm shadow-none"> 차량목록으로 돌아가기 </router-link>
        <car-data-table hover :totalPage="totalPage" :curPage="curPage">
            <template slot="header">
                <b-thead>
                    <b-tr>
                        <b-th> CAN TYPE </b-th>
                        <b-th> 단말기 번호 </b-th>
                        <b-th> 정보발생 일시 </b-th>
                        <b-th> 총 주행거리(Km) </b-th>
                        <b-th> 총 동작시간(sec) </b-th>
                        <b-th> 배터리 누적 충전 전류량(Ah) </b-th>
                        <b-th> 배터리 누적 방전 전류량(Ah) </b-th>
                        <b-th> 배터리 누적 충전 전력량(kWh) </b-th>
                        <b-th> 배터리 누적 방전 전력량(kWh) </b-th>
                        <b-th> 배터리 최대 충전 가능 파워 </b-th>
                        <b-th> 배터리 최대 방전 가능 파워 </b-th>
                        <b-th> 기기 및 통신 상태 </b-th>
                        <b-th> MCU 상태 </b-th>
                        <b-th> MCU 메인 릴레이 OFF 요청 </b-th>
                        <b-th> 모터 PWM ON/OFF 상태 </b-th>
                        <b-th> BMS 상태 </b-th>
                        <b-th> 배터리 히터 릴레이 상태 </b-th>
                        <b-th> HV PTC 작동상태 </b-th>
                        <b-th> 패들 쉬프트 스위치 </b-th>
                        <b-th> SOH 상태(%) </b-th>
                        <b-th> BMS 배터리 충전 상태(%) </b-th>
                        <b-th> 디스플레이 SOC(%) </b-th>
                        <b-th> 충전 정상 진행 상태 </b-th>
                        <b-th> EV 준비상태 </b-th>
                        <b-th> 브레이크 스위치 </b-th>
                        <b-th> 가속페달(%) </b-th>
                        <b-th> 차속(Km/h) </b-th>
                        <b-th> 현재 구동모터 속도(RPM) </b-th>
                        <b-th> 현재 구동모터 토크(Nm) </b-th>
                        <b-th> 모터 회전수 </b-th>
                        <b-th> 에어컨 컴프레서 동작 RPM(RPM) </b-th>
                        <b-th> 배터리 팩 전압(V) </b-th>
                        <b-th> 최대 셀 전압(V) </b-th>
                        <b-th> 최고 셀 전압 번호 </b-th>
                        <b-th> 최소 셀 전압(V) </b-th>
                        <b-th> 최소 셀 전압 번호 </b-th>
                        <b-th> 배터리 셀 전압(V) </b-th>
                        <b-th> 인버터 커패시터 전압(V) </b-th>
                        <b-th> LDC 출력 전압(V) </b-th>
                        <b-th> 인버터 DC 입력전압(V) </b-th>
                        <b-th> AC 입력 전압(V) </b-th>
                        <b-th> 배터리 팩 전류(A) </b-th>
                        <b-th> 구동 모터 상전류(Arms) </b-th>
                        <b-th> LDC 출력 전류(A) </b-th>
                        <b-th> 구동 모터 온도(℃) </b-th>
                        <b-th> 인버터 온도(℃) </b-th>
                        <b-th> 방열판 온도(℃) </b-th>
                        <b-th> IGBT 온도(℃) </b-th>
                        <b-th> 배터리 모듈 온도 1(℃) </b-th>
                        <b-th> 배터리 모듈 온도 2(℃) </b-th>
                        <b-th> 배터리 모듈 온도 3(℃) </b-th>
                        <b-th> 배터리 모듈 온도 4(℃) </b-th>
                        <b-th> 배터리 최대 셀 온도(℃) </b-th>
                        <b-th> 배터리 최소 셀 온도(℃) </b-th>
                        <b-th> 히터 1 온도(℃) </b-th>
                        <b-th> 배터리 냉각수 인렛 온도(℃) </b-th>
                        <b-th> 배터리 PRA 버스바 온도(℃) </b-th>
                        <b-th> 실내 온도 센서 - front(℃) </b-th>
                        <b-th> 외기 온도 센서(℃) </b-th>
                        <b-th> 보조 배터리 전압(V) </b-th>
                        <b-th> 보조 배터리 전류(A) </b-th>
                        <b-th> 보조 배터리 온도(℃) </b-th>
                        <b-th> 보조 배터리 SOC(%) </b-th>
                        <b-th> OBC 출력 전압(V) </b-th>
                        <b-th> OBC 출력 전류(A) </b-th>
                        <b-th> OBC 고장 상태 </b-th>
                        <b-th> OBC 충전 완료 </b-th>
                        <b-th> OBC 충전 수행 적산 횟수 </b-th>
                        <b-th> OBC 충전 적산 시간(min) </b-th>
                        <b-th> 절연저항(KOhm) </b-th>
                    </b-tr>
                </b-thead>
            </template>
            <template slot="body">
                <b-tbody>
                    <b-tr v-for="(item, index) in items" :key="index">
                        <b-td> {{ item.idx }} </b-td>
                        <b-td> {{ item.id }} </b-td>
                        <b-td> {{ item.c_date }} </b-td>
                        <b-td> {{ item.t_dist }} </b-td>
                        <b-td> {{ item.t_atime }} </b-td>
                        <b-td> {{ item.bacc }} </b-td>
                        <b-td> {{ item.badc }} </b-td>
                        <b-td> {{ item.bacp }} </b-td>
                        <b-td> {{ item.badp }} </b-td>
                        <b-td> {{ item.bmcpp }} </b-td>
                        <b-td> {{ item.bmdpp }} </b-td>
                        <b-td> {{ item.p_status }} </b-td>
                        <b-td> {{ item.mcu_state }} </b-td>
                        <b-td> {{ item.mcurr }} </b-td>
                        <b-td> {{ item.pwm }} </b-td>
                        <b-td> {{ item.bms_state }} </b-td>
                        <b-td> {{ item.bhr_state }} </b-td>
                        <b-td> {{ item.hvptc }} </b-td>
                        <b-td> {{ item.pss }} </b-td>
                        <b-td> {{ item.bsoh }} </b-td>
                        <b-td> {{ item.bcs }} </b-td>
                        <b-td> {{ item.bsoc }} </b-td>
                        <b-td> {{ item.c_state }} </b-td>
                        <b-td> {{ item.evr }} </b-td>
                        <b-td> {{ item.brk }} </b-td>
                        <b-td> {{ item.epd }} </b-td>
                        <b-td> {{ item.km }} </b-td>
                        <b-td> {{ item.rpm }} </b-td>
                        <b-td> {{ item.nm }} </b-td>
                        <b-td> {{ item.m_rpm }} </b-td>
                        <b-td> {{ item.acrpm }} </b-td>
                        <b-td> {{ item.bpc_v }} </b-td>
                        <b-td> {{ item.maxcv }} </b-td>
                        <b-td> {{ item.maxcvn }} </b-td>
                        <b-td> {{ item.mincv }} </b-td>
                        <b-td> {{ item.mincvn }} </b-td>
                        <b-td class="cv" v-b-modal.modal-1 @click="getCv(index)"> 셀 전압 <i class="link_icon"> 데이터 </i>
                        </b-td>
                        <b-td> {{ item.icv }} </b-td>
                        <b-td> {{ item.lov }} </b-td>
                        <b-td> {{ item.idiv }} </b-td>
                        <b-td> {{ item.aciv }} </b-td>
                        <b-td> {{ item.bpc_a }} </b-td>
                        <b-td> {{ item.arms }} </b-td>
                        <b-td> {{ item.loc }} </b-td>
                        <b-td> {{ item.mtt }} </b-td>
                        <b-td> {{ item.ivtt }} </b-td>
                        <b-td> {{ item.hst }} </b-td>
                        <b-td> {{ item.igbtt }} </b-td>
                        <b-td> {{ item.bmt_1 }} </b-td>
                        <b-td> {{ item.bmt_2 }} </b-td>
                        <b-td> {{ item.bmt_3 }} </b-td>
                        <b-td> {{ item.bmt_4 }} </b-td>
                        <b-td> {{ item.maxct }} </b-td>
                        <b-td> {{ item.minct }} </b-td>
                        <b-td> {{ item.ht_1 }} </b-td>
                        <b-td> {{ item.inlt }} </b-td>
                        <b-td> {{ item.bbt }} </b-td>
                        <b-td> {{ item.itsf }} </b-td>
                        <b-td> {{ item.ets }} </b-td>
                        <b-td> {{ item.sbv }} </b-td>
                        <b-td> {{ item.sbc }} </b-td>
                        <b-td> {{ item.sbt }} </b-td>
                        <b-td> {{ item.sbsoc }} </b-td>
                        <b-td> {{ item.oov }} </b-td>
                        <b-td> {{ item.ooc }} </b-td>
                        <b-td> {{ item.o_state }} </b-td>
                        <b-td> {{ item.oce }} </b-td>
                        <b-td> {{ item.occ }} </b-td>
                        <b-td> {{ item.o_ctime }} </b-td>
                        <b-td> {{ item.ir }} </b-td>
                    </b-tr>
                </b-tbody>
            </template>
        </car-data-table>

        <b-modal id="modal-1" title="셀 전압" hide-footer size="sm">
            <cv-list :items="cv" />
        </b-modal>
    </div>
</template>

<script>
import carDataTable from '@/components/common/table/DataTable'
import cvList from '@/views/data/CvList'

import ax from '@/api/data'

export default {
    components: {
        carDataTable,
        cvList
    },

    props: {
        value: {
            type: Object
        }
    },

    data() {
        return {
            curPage: parseInt(this.$route.query.page) || 1,
            totalPage: 1,
            items: [],
            targetData: {},
            cv: []
        }
    },

    created() {
        if (!this.targetData.id) this.init()
    },

    methods: {
        init() {
            if (!this.targetData.id) {
                this.targetData = this.value
            }

            let sk = window.location.hash.slice(1)
            ax.data(this.curPage, sk, this.targetData.id, this.targetData.sdate, this.targetData.edate, (data) => {
                if (data) {
                    this.items = data.items
                    this.totalPage = data.totalPage
                } else {
                    this.items = []
                    this.totalPage = 1
                }
            })
        },

        getCv(v) {
            this.cv = this.items[v].cv.split(',')
        }
    },

    watch: {
        '$route.query': function () {
            this.curPage = parseInt(this.$route.query.page) || 1
            this.init()
        }
    }
}
</script>

<style lang="scss" scoped>
.cv:hover {
    text-decoration: underline;
    text-underline-position: under;
}

.link_icon {
    font-size: 0px;
    width: 14px;
    height: 14px;
    background-image: url(/img/icon/icons_link_16.png);
    background-size: cover;
    display: inline-block;
    margin-bottom: 2px;
    vertical-align: middle;
}

.btn {
    vertical-align: middle;
    margin: 10px 5px 10px 10px;
    background: #FFFFFF;
    border: 1px solid #E5E5E5;
    box-sizing: border-box;
    border-radius: 100px;
    color: #979799;
    padding: 3px 20px !important;
}

.btn:hover {
    background: #979799;
    border: 1px solid #979799;
    color: #FFFFFF;
}
</style>